
document.addEventListener("DOMContentLoaded", function() {
  var blogSearchInput = document.getElementById("blog-search-input");
  var blogSearchResultContent =  document.getElementById("blog-search-results");
  var blogSearchResultClose = document.querySelector(".blog-search-result__close");
  var blogSearchResultContainer = document.querySelector(".blog-search-result_container");
  var blogSearchCover = document.getElementById('searchBarCover');
  var blogSearchForm = document.getElementById('blog-search-form');
  var clearButton = document.getElementById("clear-button");

  blogSearchInput.addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
        e.preventDefault();
        var searchedText = blogSearchInput.value;
        if (searchedText) {
          const storeURL = "https://" + window.location.hostname;
          var  searchUrl= storeURL + "/search?q=" + encodeURIComponent(searchedText) + "&view=blog&type=article";
            window.location.href = searchUrl;
        }
    }
  });

  blogSearchInput.addEventListener("input", function(e) {
    var query = e.target.value;
    if (query == "") {
      hideBlogSearchResults();
    }
    else {
      searchBlogs(query);
    }
    toggleClearButtonVisibility();
  });

  blogSearchInput.addEventListener("blur", function() {
    if (query == "") {
      hideBlogSearchResults();
    }
  });

  blogSearchResultClose.addEventListener("click", function() {
    hideBlogSearchResults();
  });

  document.addEventListener("click", function(event) {
    if (!event.target.matches("#blog-search-input") && !event.target.closest("#blog-search-results")) {
      hideBlogSearchResults();
    }
  });

  clearButton.addEventListener("click", function() {
    blogSearchInput.value = "";
    clearButton.classList.add("hidden");
  });

  function searchBlogs(searchedText) {
    if (searchedText) {
      const storeURL = "https://" + window.location.hostname;
      var blogResultLink = storeURL + "/search?q=" + encodeURIComponent(searchedText) + "&view=blog&type=article";
      var blogResultLinkSelector = document.querySelector('.blog-search-result__link');
      blogSearchCover.classList.add('blog-seach__cover');
      blogSearchForm.classList.add('blog-search__z-index');
      blogSearchResultContainer.classList.add('blog-search__z-index');
      if (blogResultLinkSelector) {
        blogResultLinkSelector.href = blogResultLink;
      }
      fetch(blogResultLink)
        .then(response => response.text())
        .then(htmlContent => {
            displayResults(htmlContent);
        })
        .catch(error => console.error('Error fetching blog search results:', error));
    }
  }
    
  function displayResults(htmlContent) {
    var tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlContent;
    var ulElement = tempContainer.querySelector("#shopify-section-main-search-blog ul");
    blogSearchResultContent.innerHTML = "";
    if (blogSearchInput.value != "") {
      blogSearchResultContainer.classList.remove('hidden');
    }
    if (ulElement) {
      var clonedUl = ulElement.cloneNode(false);
      var liElements = ulElement.querySelectorAll("li");
      for (var i = 0; i < Math.min(liElements.length, 4); i++) {
        var clonedLi = liElements[i].cloneNode(true);
        var readMoreElement = document.createElement('span');
        readMoreElement.innerHTML = "Read More";
        readMoreElement.classList.add('blog-search-result__read');
        clonedLi.querySelector('.blog-search-result__content').appendChild(readMoreElement);
        clonedUl.appendChild(clonedLi);
      }
      blogSearchResultContent.appendChild(clonedUl);
    } else {
      var noBlogSearchResults = document.createElement('p');
      noBlogSearchResults.innerHTML = "No results found.";
      blogSearchResultContent.appendChild(noBlogSearchResults);
    }
  }
    
  function hideBlogSearchResults() {
    blogSearchResultContainer.classList.add('hidden');
    blogSearchCover.classList.remove('blog-seach__cover');
    blogSearchForm.classList.remove('blog-search__z-index');
    blogSearchResultContainer.classList.remove('blog-search__z-index');
  }
  
  function toggleClearButtonVisibility() {
    if (blogSearchInput.value !== "") {
      clearButton.classList.remove("hidden");
    } else {
      clearButton.classList.add("hidden");
    }
  }
});